import { render } from "./driver.longhorn.io.vue?vue&type=template&id=334a8240"
import script from "./driver.longhorn.io.vue?vue&type=script&lang=js"
export * from "./driver.longhorn.io.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__